import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_lead-capture-roof/artifacts/qluhpuzm_image.jpeg"
              alt="LLDLS Smart Energy"
              className="h-12 sm:h-14"
            />
          </Link>
          
          <nav className="hidden md:flex items-center gap-8">
            <a href="#form" className="text-slate-600 hover:text-slate-900 transition-colors font-medium">
              Devis gratuit
            </a>
            <a href="#temoignages" className="text-slate-600 hover:text-slate-900 transition-colors font-medium">
              Témoignages
            </a>
            <a href="#faq" className="text-slate-600 hover:text-slate-900 transition-colors font-medium">
              FAQ
            </a>
          </nav>

          <a 
            href="#form"
            className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2.5 rounded-full font-semibold transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-amber-500/25"
            data-testid="header-cta-button"
          >
            <span className="hidden sm:inline">Demander un devis</span>
            <span className="sm:hidden">Devis</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
